import { ClinicGlobalStore } from './clinic-global.store';
import { ClinicHealthRecordService } from '../services/clinic-health-record/clinic-health-record.service';
import { GlobalStore } from '@web/csl-lib-store';
import { HealthRecordMeta } from '@web/csl-lib-models';
import { HealthRecordMetaState } from './health-record-meta.state';
import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { pipe, switchMap, tap } from 'rxjs';
import { rxMethod } from '@ngrx/signals/rxjs-interop';


const initialState: HealthRecordMetaState = {
  healthRecordId: '',
  healthRecordMeta: null,
  isLoading: false,
  error: null
}

export const ClinicHealthRecordMetaStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods(
    (store,
     clinicHealthRecordService = inject(ClinicHealthRecordService),
     clinicGlobalStore = inject(ClinicGlobalStore),
     globalStore = inject(GlobalStore)
  ) => ({
    setHealthRecordId(healthRecordId: string) {
      patchState(store, { healthRecordId: healthRecordId });
    },
    loadHealthRecordMeta: rxMethod<string>(
      pipe(
        switchMap((healthRecordId: string) => {
          globalStore.setLoading();
          return clinicHealthRecordService
            .getHealthRecordMeta(clinicGlobalStore.clinicId()!, healthRecordId)
            .pipe(
              tap({
                next: (meta: HealthRecordMeta) => {
                  // Store IDs as upper case to make comparisons case-insensitive
                  meta.id = meta.id.toUpperCase();
                  meta.ownerUserId = meta.ownerUserId.toUpperCase();
                  meta.patientId = meta.patientId.toUpperCase();

                  patchState(store, {
                    healthRecordMeta: meta,
                    healthRecordId: healthRecordId.toUpperCase(),
                    isLoading: false }
                  );
                  globalStore.unsetLoading();
                },
                error: (e) => {
                  console.error(e);
                //  globalStore.unsetLoading();
                },
                finalize: () => {
                  globalStore.unsetLoading();
                }
              })
            );
        })
      )
    ),
  })),
);
